import React from 'react';
import { Grid } from '@material-ui/core';
import { CheckCircleOutline, ErrorOutline, HighlightOff, RadioButtonUnchecked } from '@material-ui/icons';
import { css } from '@emotion/react';
import { SectionLabel, StatusBadge } from '../blocks';
import { statusBadge } from './utils';

// One icon per StatusBadge tone, so a badge reads without relying on its color.
const TONE_ICONS = {
    success: CheckCircleOutline,
    warning: ErrorOutline,
    danger: HighlightOff,
    neutral: RadioButtonUnchecked,
};

const BadgeRow = ({ label, badge }) => {
    const Icon = badge ? TONE_ICONS[badge.tone] : null;
    return (
        <Grid
            container
            css={css`
                align-items: center;
                gap: 6px;

                /* StatusBadge's wrapper span would otherwise open a line box taller than the pill. */
                & > .onward-design {
                    display: flex;
                }
            `}
        >
            <SectionLabel>{label}</SectionLabel>
            <StatusBadge tone={badge?.tone}>
                {Icon ? <Icon aria-hidden style={{ fontSize: 13 }} /> : null}
                {badge?.label || '—'}
            </StatusBadge>
        </Grid>
    );
};

// `statuses`: the carrier's `{ tariff, integration }` from useCarrierDirectory; unset while loading.
const CarrierBadges = ({ statuses }) => (
    <Grid
        container
        direction="column"
        css={css`
            flex-wrap: nowrap;
            gap: 4px;
        `}
    >
        <BadgeRow label="Integration:" badge={statusBadge(statuses, 'integration')} />
        <BadgeRow label="Tariff:" badge={statusBadge(statuses, 'tariff')} />
    </Grid>
);

export default CarrierBadges;
